import { render, staticRenderFns } from "./interferTip.vue?vue&type=template&id=5fc0c89a&"
import script from "./interferTip.vue?vue&type=script&lang=js&"
export * from "./interferTip.vue?vue&type=script&lang=js&"
import style0 from "./interferTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports